import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IUserDataProfilesService } from 'vscode/vscode/vs/platform/userDataProfile/common/userDataProfile.service';
import { IUriIdentityService } from 'vscode/vscode/vs/platform/uriIdentity/common/uriIdentity.service';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { AbstractExtensionsProfileScannerService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionsProfileScannerService';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';

let ExtensionsProfileScannerService = class ExtensionsProfileScannerService extends AbstractExtensionsProfileScannerService {
    constructor(environmentService, fileService, userDataProfilesService, uriIdentityService, telemetryService, logService) {
        super(environmentService.userRoamingDataHome, fileService, userDataProfilesService, uriIdentityService, telemetryService, logService);
    }
};
ExtensionsProfileScannerService = ( __decorate([
    ( __param(0, IWorkbenchEnvironmentService)),
    ( __param(1, IFileService)),
    ( __param(2, IUserDataProfilesService)),
    ( __param(3, IUriIdentityService)),
    ( __param(4, ITelemetryService)),
    ( __param(5, ILogService))
], ExtensionsProfileScannerService));

export { ExtensionsProfileScannerService };
